<template>
  <div>
    <el-dialog
      :title="$t('cancelAccount.protocol')"
      :visible.sync="agreementDia"
      width="40%"
      custom-class="agreementDia-cla"
    >
      <div>
        <iframe
          frameborder="0"
          name="agreementFrame"
          width="100%"
          onload="this.height=agreementFrame.document.body.scrollHeight"
          :src="agreementSrc"
          scrolling="no"
        ></iframe>
        <!-- <div style="text-align:center;padding:0px">
          <el-button @click="showCancelAccountTip" type="danger"
            >{{ $t('cancelAccount.withdrawal') }}
          </el-button>
        </div> -->
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('common.notice')"
      :visible.sync="cancelAccountTipDia"
      width="30%"
    >
      <div style="display: flex;align-items: center;">
        <i
          style="font-size:60px;color:#FF4D4D"
          class="el-icon-warning-outline"
        ></i>
        <div style="padding-left:20px">
          {{ $t('cancelAccount.cancelTip') }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="cancelAccountTipDia = false">{{
          $t('common.not')
        }}</el-button>
        <el-button type="danger" @click="showValidateDia">{{
          $t('common.yes')
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      custom-class="validataDia-cla"
      :title="$t('common.notice')"
      :visible.sync="validateDia"
      width="30%"
    >
      <div class="validate-row">
        <div style="width:80px">
          {{ $t('cancelAccount.verificationType') }}：
        </div>
        <div style="width:200px">
          {{
            validateType === 'email'
              ? emailFormat(validateAccount)
              : phoneFormat(validateAccount)
          }}
        </div>
        <div>
          <el-button
            v-if="showChange"
            type="text"
            @click="changeValidateType"
            >{{ $t('cancelAccount.changeType') }}</el-button
          >
        </div>
      </div>
      <div class="validate-row">
        <div style="width:80px">{{ $t('cancelAccount.code') }}：</div>
        <div style="width:200px">
          <el-input
            v-model="validateCode"
            :placeholder="$t('cancelAccount.inputCode')"
          ></el-input>
        </div>
        <div>
          <el-button
            :disabled="btnDisable"
            type="primary"
            @click="getValidateCode"
            >{{ btnText }}</el-button
          >
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button plain @click="validateDia = false">{{
          $t('common.not')
        }}</el-button>
        <el-button
          :disabled="validateCode === ''"
          type="danger"
          @click="submitValidateDia"
          >{{ $t('common.yes') }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('common.notice')"
      :visible.sync="cancleAccountDia"
      width="30%"
    >
      <div style="display: flex;align-items: center;">
        <i
          style="font-size:60px;color:#FF4D4D"
          class="el-icon-warning-outline"
        ></i>
        <div style="padding-left:20px">
          {{ $t('cancelAccount.exportTip') }}
          <!-- <span @click="toExportData" class="export-btn">{{
            $t('cancelAccount.clickHere')
          }}</span> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="cancleAccountDia = false">{{
          $t('common.not')
        }}</el-button>
        <el-button type="danger" @click="submitCancelAccount">{{
          $t('cancelAccount.withdraw')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLanguage } from '@/utils/utils.js'
import * as centerApi from '@/services/userCenter.js'
export default {
  data() {
    return {
      agreementDia: false,
      cancelAccountTipDia: false,
      validateDia: false,
      cancleAccountDia: false,
      agreementType: '',
      useLang: '',
      validateCode: '',
      validateType: '',
      validateAccount: '',
      btnDisable: false,
      btnText: this.$t('cancelAccount.click')
    }
  },
  props: {
    userInfo: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  mounted() {
    let lang = getLanguage('language')
    if (lang === 'zh-cn') {
      this.useLang = 'cn'
    } else {
      this.useLang = 'en'
    }
  },
  computed: {
    agreementSrc() {
      return `/static/agreement/${this.useLang}/${this.agreementType}.html`
    },
    showChange() {
      return (
        this.userInfo.emailState === '1' && this.userInfo.phoneState === '1'
      )
    }
  },
  watch: {
    userInfo: {
      handler: function(val) {
        if (val.emailState === '1') {
          this.validateType = 'email'
          this.validateAccount = val.email
        }
        if (val.phoneState === '1') {
          this.validateType = 'phone'
          this.validateAccount = val.phone
        }
      },
      immediate: true
    }
  },
  methods: {
    showAgreementDia(agreementType) {
      this.agreementType = agreementType
      this.agreementDia = true
    },
    showCancelAccountTip() {
      this.agreementDia = false
      this.cancelAccountTipDia = true
    },
    showValidateDia() {
      this.btnText = this.$t('cancelAccount.click')
      this.btnDisable = false
      this.cancelAccountTipDia = false
      this.validateDia = true
    },
    changeValidateType() {
      if (this.validateType === 'phone') {
        this.validateType = 'email'
        this.validateAccount = this.userInfo.email
      } else {
        this.validateType = 'phone'
        this.validateAccount = this.userInfo.phone
      }
    },
    timeOutFunction() {
      let count = 60
      let aa = setInterval(() => {
        count--
        this.btnText = count
        if (count === 0) {
          this.btnText = this.$t('cancelAccount.click')
          this.btnDisable = false
          clearInterval(aa)
        }
      }, 1000)
    },
    getValidateCode() {
      this.btnDisable = true
      let params = {
        type: 'accountCancellation'
      }
      if (this.validateType === 'email') {
        params.email = this.validateAccount
        centerApi
          .getEmailCode(params)
          .then(data => {
            if (data.code === '00000000') {
              //  this.$refs.timing.beginTime()
              this.timeOutFunction()
            } else {
              this.btnDisable = false
              this.errorMessage(data.message)
            }
          })
          .catch(e => {
            this.btnDisable = false
            this.errorMessage(e)
          })
      } else if (this.validateType === 'phone') {
        params.phone = this.userInfo.prefix + this.validateAccount
        centerApi
          .sendPhoneCode(params)
          .then(data => {
            if (data.code === '00000000') {
              this.timeOutFunction()
            } else {
              this.btnDisable = false
              this.errorMessage(data.message)
            }
          })
          .catch(e => {
            this.btnDisable = false
            this.errorMessage(e)
          })
      }
      // 获取验证码
    },
    submitValidateDia() {
      let params = {
        type: 'accountCancellation',
        code: this.validateCode
      }
      if (this.validateType === 'email') {
        params.loginName = this.validateAccount
      } else if (this.validateType === 'phone') {
        params.loginName = this.userInfo.prefix + this.validateAccount
      }
      centerApi
        .verifyCode(params)
        .then(data => {
          if (data.code === '00000000') {
            this.validateDia = false
            this.cancleAccountDia = true
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    submitCancelAccount() {
      let params = {
        type: 'accountCancellation',
        code: this.validateCode
      }
      if (this.validateType === 'email') {
        params.loginName = this.validateAccount
      } else if (this.validateType === 'phone') {
        params.loginName = this.userInfo.prefix + this.validateAccount
      }
      centerApi
        .accountCancellation(params)
        .then(data => {
          if (data.code === '00000000') {
            this.$message.success(
              this.$t('successOperation.cancellationSuccess')
            )
            setTimeout(() => {
              this.$router.push({ path: '/login' })
            }, 1500)
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => console.log(e))
    },

    toExportData() {
      let routeTwo = this.$router.resolve({
        name: 'exportData'
      })
      window.open(routeTwo.href, '_blank')
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .agreementDia-cla {
  .el-dialog__body {
    padding: 10px !important;
    height: 50vh;
    overflow: auto;
  }
}

.validate-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
  line-height: 50px;
  padding: 0px 20px;
  > div {
    margin-right: 20px;
  }
}

.export-btn {
  margin-left: 5px;
  cursor: pointer;
  color: #4db22f;
}
/deep/.validataDia-cla {
  min-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/modules/personCenter/dialog/cancelAccount.vue